<template>
  <div class="container-fluid">
    <page-header
      :page="page"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <action-button
          v-show="isCreateMode"
          text="Guardar"
          variant="success m-1"
          i="fas fa-save"
          :responsive="false"
          @click="createMetaPrTable"
        />
        <action-button
          v-show="isEditMode && !existPei"
          text="Guardar"
          variant="success m-1"
          i="fas fa-save"
          :responsive="false"
          @click="editMetaPrTable"
        />
        <action-button
          v-show="canAdd"
          text="Añadir"
          variant="outline-success m-1"
          i="fas fa-file-plus"
          :responsive="false"
          @click="getConfMetaPrTable"
        />
      </template>
    </page-header>

    <div class="col-md-3 bg-gray-1 py-2 col-sm-12">
      <div class="row">
        <div class="col-sm my-1">
          <custom-drop-down
            v-model="selectedYear"
            fieldkey="id"
            fieldname="description"
            :clearable="false"
            :options="years"
            placeholder="Seleccione"
          />
        </div>
        <div class="col-sm-12 my-1 d-flex justify-content-end col-md-4">
          <action-button
            text="Buscar"
            variant="success"
            i="fas fa-search"
            @click="search"
          />
        </div>
      </div>
    </div>

    <custom-separator
      text="Información de evaluaciones"
      class="my-4 custom-separator-line"
    />

    <div v-if="showNotResults" class="row pt-3">
      <div class="col-12 pt-4">
        <div class="col-12 pt-0 text-center">
          <div class="row d-flex justify-content-center">
            <div class="col-md-7 col-sm-12">
              <CustomResultNotFound :text="noResultsText" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <row
        v-for="(item, monthIndex) in results"
        :key="monthIndex"
        v-model="results[monthIndex]"
        :school-grades="schoolGrades"
        :disabled="existPei"
        :track-changes="isEditMode && !existPei"
      />

      <div class="row">
        <div class="col-12">
          <span class="font-weight-normal">
            * Estudiantes que nacieron en esta fecha están en un nivel que no
            necesita ser evaluado
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import alertMixin from '@/mixin/alert.mixin';
import CustomDropDown from 'custom-drop-down';
import CustomSeparator from 'custom-separator';
import CustomResultNotFound from 'custom-result-not-found';
import Row from './components/Row';

import {
  getAcademicYears,
  getSchoolGrades,
  getMetaPrData,
  getConfMetaPrData,
  createMetaPrTable,
  editMetaPrTable,
  existPeiForAcademicYear,
} from '@/modules/operation-metapr-management/api';

export default {
  name: 'MetaPR',
  mixins: [alertMixin],
  components: {
    PageHeader,
    ActionButton,
    CustomDropDown,
    CustomSeparator,
    Row,
    CustomResultNotFound,
  },
  data() {
    return {
      isCreateMode: false,
      isEditMode: false,
      canAdd: false,
      existPei: false,
      years: [],
      selectedYear: null,
      schoolGrades: [],
      results: [],
      noResultsText:
        'Para el año seleccionado no existe Tabla de conversión de edad a nivel de grado para Meta-PR Alterna. Para crear la misma presione el botón Añadir.',
    };
  },
  computed: {
    showNotResults() {
      return this.results.length == 0;
    },
    page() {
      return {
        icon: 'fas fa-user-tie',
        title: 'Tabla META-PR Alterna',
        routes: [
          'Inicio',
          'Operaciones',
          'Tabla de conversión de edad a nivel de grado',
        ],
      };
    },
  },
  methods: {
    search() {
      this.isCreateMode = false;
      if (this.selectedYear?.id) {
        getMetaPrData(this.selectedYear.id).then((res) => {
          res.data.forEach((x) => {
            x.metaPrItems.forEach((item) => {
              item.gradeId = this.schoolGrades.find(
                (x) => x.id == item.gradeId
              );
            });
          });

          this.results = res.data;

          if (this.results.length > 0) {
            // Setear el modo Editar en TRUE
            this.isEditMode = true;
            this.isCreateMode = false;
            this.canAdd = false;

            // Chequear si existe Pei para ese Año Académico
            existPeiForAcademicYear(this.selectedYear.id).then((res) => {
              this.existPei = res.data;
              if (this.existPei) {
                this.ShowToast(
                  'Alerta',
                  'No es posible cambiar el nivel de grado ya que el año académico seleccionado se hizo revisión del PEI.',
                  'error'
                );
              }
            });
          } else {
            this.canAdd = true;
          }
        });
      }
    },
    getConfMetaPrTable() {
      if (this.selectedYear?.id) {
        getConfMetaPrData(this.selectedYear.id).then((res) => {
          res.data.forEach((x) => {
            x.metaPrItems.forEach((item) => {
              item.gradeId = this.schoolGrades.find(
                (x) => x.id == item.gradeId
              );
            });
          });

          this.results = res.data;

          // Setear el modo Editar en FALSE
          this.isEditMode = false;
          this.canAdd = false;
          this.isCreateMode = true;
          this.existPei = false;
        });
      }
    },
    createMetaPrTable() {
      createMetaPrTable(this.results)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'La tabla de conversión de edad a nivel de grado ha sido creada exitosamente.',
              'success'
            );
            this.search();
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    editMetaPrTable() {
      editMetaPrTable(this.results)
        .then((res) => {
          if (res.status == 200) {
            this.ShowToast(
              'Proceso exitoso.',
              'La tabla Meta-PR fue actualizada exitosamente.',
              'success'
            );
          }
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async loadResources() {
      getSchoolGrades().then((res) => {
        res.data.push({ id: 0, name: '*' });
        this.schoolGrades = res.data;
      });

      await getAcademicYears().then(({ data }) => {
        this.years = data;
        this.selectedYear = this.currentAcademicYear();
      });
    },
  },
  async mounted() {
    await this.loadResources();
    await this.search();
  },
};
</script>
<style scoped>
@media only screen and (max-width: 375px) {
  ::v-deep .vs__search {
    font-size: 12px !important;
  }

  ::v-deep .vs__selected {
    font-size: 12px !important;
  }

  ::v-deep .vs__dropdown-menu {
    font-size: 12px !important;
  }

  ::v-deep .separator-custom__text {
    font-size: 12px !important;
    font-weight: normal;
    padding: 2px 16px !important;
  }
}
</style>
